import { publicIdentityClient, Server } from '@wajeez-web/core/api-base';
import { store } from '@wajeez-web/stores/base';
import { Mutex, decodeToken } from '@wajeez-web/core/utils';
import { getQueryFromUrl } from '@wajeez-web/core/utils';
import { AlertType } from '@wajeez-web/stores/common';
import { CommonActions } from '@wajeez-web/stores/common';

import { AuthActions, getAuthState } from '..';
import {
  getLocalAccessToken,
  getLocalRefreshToken,
  setUser,
  updateIsUrlToken,
  updateLocalAccessToken,
  updateUser,
} from './TokenStorageManager';
import { User } from '../types';

const tokenMutex = new Mutex();

type TokenUser = {
  Id: string;
  Name: string;
  PhoneNumber: string;
  Email: string;
  HasPassword: boolean;
  Gender: any;
  IsVerified: boolean;
  IsBlocked: boolean;
  CreatedDate: string;
  Picture: any;
  LastLoginDate: string;
  ReferralCode: string;
  IsNewUser: boolean;
  OnboardingCompleted: boolean;
  B2BOnboardingCompleted: boolean;
  AutoPlayDisabled: boolean;
  NextTitleDisabled: boolean;
  PreferredPlayerMode: number;
};

class TokenService {
  checkTokenExpiry(): boolean {
    const now = new Date();
    const nowInSec = now.getTime() / 1000;
    const tokenExpiry = getAuthState(store).tokenExpiry;

    if (tokenExpiry >= nowInSec + 10) {
      return true;
    }
    return false;
  }

  async validateAccessToken(accessToken: string): Promise<string | null> {
    if (this.checkTokenExpiry()) {
      return accessToken;
    } else {
      return await this.refresh();
    }
  }

  async getAccessTokenForUsageService(): Promise<string> {
    return await tokenMutex.dispatch(async () => {
      const token = getLocalAccessToken();
      if (token == null || token == undefined || token == '') return '';
      const accessToken = await this.validateAccessToken(token);
      if (accessToken == null || accessToken == undefined || accessToken == '')
        return '';
      return accessToken;
    });
  }

  async setAccessTokenFromUrlToLocal(): Promise<void> {
    const token = getQueryFromUrl('token');
    console.log('token form url service', token);

    if (token) {
      console.log('we have token', token);
      try {
        // updateQueryParam('token', undefined);

        await store.dispatch(AuthActions.signOutAsync());

        const decodedToken = decodeToken(token);

        const now = new Date();
        const nowInSec = now.getTime() / 1000;
        const tokenExpiry = decodedToken.exp ?? 0;

        if (tokenExpiry < nowInSec + 10) {
          store.dispatch(
            CommonActions.setAlert({
              for: 'page',
              show: true,
              messages: [
                {
                  code: 400,
                  field: null,
                  message: 'رمز الوصول غير فعال، يرجى تسجيل الدخول',
                },
              ],
              type: AlertType.ERROR,
            })
          );

          return;
        }

        let user: User = {
          autoPlayDisabled: false,
          email: '',
          id: '',
          isVerified: false,
          name: '',
          nextTitleDisabled: false,
          picture: '',
        };

        store.dispatch(
          AuthActions.setUser({
            user,
            token,
            refreshToken: '',
          })
        );

        let userData: Partial<TokenUser> | undefined = decodedToken.UD
          ? JSON.parse(decodedToken.UD)
          : undefined;

        if (!userData) {
          const userInfoDetails = await this.getUserInfoById(token);

          userData = {
            Id: userInfoDetails?.id || '',
            Email: userInfoDetails?.email || '',
            IsVerified: userInfoDetails?.isVerified || false,
            Name: userInfoDetails?.name || '',
          };
        }

        user = {
          autoPlayDisabled: userData?.AutoPlayDisabled ?? false,
          email: userData?.Email ?? '',
          id: userData?.Id ?? '',
          isVerified: userData?.IsVerified ?? false,
          name: userData?.Name ?? '',
          nextTitleDisabled: userData?.NextTitleDisabled ?? false,
          picture: userData?.Picture ?? '',
        };

        console.log('userData', userData);
        updateLocalAccessToken(token);
        updateUser(user);
        updateIsUrlToken(true);

        store.dispatch(
          AuthActions.setUser({
            user,
            token,
            refreshToken: '',
          })
        );

        console.log('token form url service done', token);
        // TODO: only remove the token param from the url and keep the rest
      } catch (error: any) {
        console.log('error in token from url', error);
        store.dispatch(
          CommonActions.setError({
            show: true,
            type: null,
          })
        );

        store.dispatch(
          CommonActions.setAlert({
            for: 'page',
            show: true,
            messages: [
              {
                code: error.code,
                field: null,
                message: 'لا يوجد لديك صلاحيات للاستمرار',
              },
            ],
            type: AlertType.ERROR,
          })
        );
      }
    }
  }

  async getUserInfoById(token: string) {
    try {
      const response = await publicIdentityClient.get(
        `api/identity/v1/Account/get-my-info`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data) {
        const parsedData = JSON.parse(response.data);

        return parsedData.data;
      }

      return {};
    } catch (error) {
      console.log(error);

      return {};
    }
  }

  async refresh() {
    try {
      const body = {
        token: getLocalAccessToken(),
        refreshToken: getLocalRefreshToken(),
      };

      if (body.token == '' || body.refreshToken == '') {
        store.dispatch(AuthActions.signOutAsync());
        return null;
      }

      const client = new Server.Server_Account_Client(
        undefined,
        publicIdentityClient
      );

      const response = await client.account_token_refresh_post_V2(body);
      const data = response?.data;
      if (data != undefined) {
        const user = {
          refreshToken: data.refreshToken ?? '',
          token: data.token ?? '',
        };
        store.dispatch(AuthActions.setRefreshToken(user));
        updateLocalAccessToken(user.token);
        setUser(user);
      }
      return data?.token ?? '';
    } catch (error) {
      store.dispatch(AuthActions.signOutAsync());
      return null;
      return Promise.reject(error);
    }
  }
}

export default new TokenService();
